import axios from 'axios';
import { handleAxiosError } from '../shared/eror/axiosError';
import type { ApiResponse } from '../shared/interfaces/ApiResponseInterface';
import type { LoginRequest, LoginResponse } from '../shared/interfaces/LoginInterface';

const BASE_URL = import.meta.env.VITE_API_URL;
const ENDPOINT = '/login';

const LoginService = {

  async login(data: LoginRequest): Promise<ApiResponse<LoginResponse>> {
    try {
      const response = await axios.post<ApiResponse<LoginResponse>>(`${BASE_URL}${ENDPOINT}`, data);
      return response.data;
    } catch (error) {
      return handleAxiosError(error);
    }
  },

  async forgotPassword(email: string): Promise<ApiResponse<void>> {
    try {
      const response = await axios.post<ApiResponse<void>>(
        `${BASE_URL}/forgot-password`, 
        { email }
      );
      return response.data;
    } catch (error) {
      return handleAxiosError(error);
    }
  },

  async refreshToken(token: string): Promise<ApiResponse<string>> {
    try {
      const response = await axios.post<ApiResponse<string>>(
        `${BASE_URL}${ENDPOINT}/refresh`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    } catch (error) {
      return handleAxiosError(error);
    }
  },

  async googleLogin(token: string): Promise<ApiResponse<LoginResponse>> {
    try {
      const response = await axios.post<ApiResponse<LoginResponse>>(
        `${BASE_URL}${ENDPOINT}/google`, token 
      );
      return response.data;
    } catch (error) {
      return handleAxiosError(error);
    }
  },

  async resetPassword(token: string, password: string): Promise<ApiResponse<void>> {
    try {
      const response = await axios.post<ApiResponse<void>>(
        `${BASE_URL}/reset-password`,
        { token, password }
      );
      return response.data;
    } catch (error) {
      return handleAxiosError(error);
    }
  },

  async updatePassword(currentPassword: string, newPassword: string): Promise<ApiResponse<boolean>> {
    try {
      const response = await axios.post<ApiResponse<boolean>>(
        `${BASE_URL}/update-password`,
        { currentPassword, newPassword }
      );
      return response.data;
    } catch (error) {
      return handleAxiosError(error);
    }
  },

};

export default LoginService;